import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="py-24 px-6 lg:px-8" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm flex flex-col md:flex-row items-center gap-10" data-id="element-18">
          <div className="w-48 h-48 md:w-64 md:h-64 shrink-0" data-id="element-19">
            <img src="https://cdn.magicpatterns.com/uploads/tgqYk7S9Yx2vRdq3qBeVLa/happy-successful-woman-posing-with-folded-arms.jpg" alt="Camila Reyes" width={512} height={512} loading="lazy" decoding="async" className="w-full h-full object-cover rounded-full shadow-md border-4 border-cream" data-id="element-20" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-21">
            <h3 className="text-sm font-bold tracking-widest text-gold uppercase mb-2" data-id="element-22">
              Creado por una experta
            </h3>
            <h2 className="text-3xl md:text-4xl font-serif font-medium text-indigo mb-2" data-id="element-23">
              Camila Reyes
            </h2>
            <p className="text-indigo/60 font-medium mb-6" data-id="element-24">
              Coach de sueño y crianza consciente
            </p>

            <p className="text-indigo/80 text-lg leading-relaxed mb-8" data-id="element-25">
              Después de acompañar a más de 2.300 familias en Latinoamérica,
              Camila reunió en este libro los cuentos que mejor funcionaron con
              sus propios hijos y sus pacientes. Su misión es simple: que ningún
              padre vuelva a dormir agotado.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-26">
              <span className="bg-blush/30 text-indigo px-4 py-2 rounded-full text-sm font-medium" data-id="element-27">
                +8 años de experiencia
              </span>
              <span className="bg-blush/30 text-indigo px-4 py-2 rounded-full text-sm font-medium" data-id="element-28">
                Madre de 2
              </span>
              <span className="bg-blush/30 text-indigo px-4 py-2 rounded-full text-sm font-medium" data-id="element-29">
                Formada en pedagogía Waldorf
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}